import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import './loading.css';

const Loading = ({ size }) => (
  <div className="loading-container">
    <FontAwesomeIcon icon={['fal', 'spinner']} spin pulse size={size} />
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/shared/Loading.js